<template>
  <!-- Footer Section Start -->
  <footer style="">
    <!-- Footer Area Start -->
    <section class="footer-Content">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-sm-12 col-xs-12">
            <div class="widget">
              <h3 class="block-title">
                <img
                  src="/img/logo_white.png"
                  class="img-responsive"
                  width="300"
                  alt="Footer Logo"
                />
              </h3>
              <div class="textwidget">
                <p>
                  Kira RH, ensemble faisons chemin.
                </p>
              </div>
            </div>
          </div>
          <div class="text-md-center col-md-4 col-sm-12 col-xs-12">
            <div class="widget">
              <h3 class="block-title">Liens rapides</h3>
              <ul class="menu">
                <li>
                  <a href="/about-us">A propos de nous</a>
                </li>
                <li>
                  <a href="/legal-notice">Mentions légales</a>
                </li>
                <li>
                  <a href="/terms-of-service">Termes & Conditions</a>
                </li>
                <li><a href="/contact-us">Contact</a></li>
              </ul>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 col-xs-12">
            <div class="widget">
              <h3 class="block-title text-md-right">Suivez nous</h3>
              <div class="bottom-social-icons social-icon text-md-end">
                <a
                  class="twitter"
                  target="_blank"
                  href="https://twitter.com/KiraRH224"
                  ><i class="ti-twitter-alt"></i
                ></a>
                <a
                  class="facebook"
                  target="_blank"
                  href="https://www.facebook.com/profile.php?id=100086559730382"
                  ><i class="ti-facebook"></i
                ></a>
                <a
                  class="linkedin"
                  target="_blank"
                  href="https://www.linkedin.com/company/kira-rh/"
                  ><i class="ti-linkedin"></i
                ></a>
              </div>
              <!--              <p>Rejoignez notre newsletter!</p>
              <form class="subscribe-box">
                <input type="text" placeholder="Votre email">
                <input type="submit" class="btn-system" value="Rejoindre">
              </form>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Footer area End -->
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style scoped></style>
